var TermsViewController = (function () {
    function TermsViewController(env, $filter, DTS, $stateParams, $state, socket, $scope, admin, config, settings) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.config = config;
        this.settings = settings;
        this.isCreateFormShow = false;
        this.profileLoaded = false;
        this.saving = {};
        this.events = {
            beingSaved: false
        };
        this.today = new Date();
        this.socket.forward('config.terms_profile', this.$scope);
        this.$scope.$on('socket:config.terms_profile', function (event, payload) {
            if (angular.isDefined(payload.error)) {
                _this.$state.go('admin.main'); // Go back to main admin
            }
            else {
                _this.data = payload.data;
                _this.profileLoaded = true;
                _this.getcorrectTerm();
            }
        });
        this.socket.forward('config.terms_profile_save', this.$scope);
        this.$scope.$on('socket:config.terms_profile_save', function (event, payload) {
            _this.events.beingSaved = false;
            if (angular.isDefined(payload.error)) {
                _this.events.serverError = payload.error;
            }
            else {
                // If successful
                _this.data.terms.push(payload.newTerm); // Add term
                _this.getcorrectTerm(); // set as the current one to show
                _this.isCreateFormShow = false;
                _this.today = new Date(); // lazy update to stop the newly-added entry appearing as a Future Term when it's not :)
            }
        });
    }
    TermsViewController.prototype.getcorrectTerm = function () {
        this.correctTerm = this.data.terms[this.data.terms.length - 1];
    };
    TermsViewController.prototype.openCreateVersionForm = function () {
        this.saving.tou = '';
        this.saving.effective_date = new Date();
        this.isCreateFormShow = true;
        this.events.beingSaved = false;
    };
    TermsViewController.prototype.changeVersion = function (version) {
        this.correctTerm = this.data.terms.filter(function (data) { return data.version === version; })[0];
    };
    TermsViewController.prototype.$onInit = function () {
        this.admin.getTermsProfile();
        this.minEffectiveDate = new Date();
    };
    TermsViewController.prototype.saveData = function () {
        var newTerm = {
            tou: this.saving.tou,
            created_by: this.env.user.email,
            created_date: Date.now(),
            version: this.data.terms[this.data.terms.length - 1].version + 1,
            effective_date: new Date(this.saving.effective_date).getTime()
        };
        //this.data.terms.push(newTerm);
        delete this.events.serverError;
        this.admin.updateTerms(newTerm); // Make call to server
        //this.isCreateFormShow = false;
        //this.getcorrectTerm();
        this.events.beingSaved = true; // Set flag to disable buttons
    };
    TermsViewController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket',
        '$scope', 'admin', 'config', 'settings'];
    return TermsViewController;
}());
var TermsViewComponent = (function () {
    function TermsViewComponent() {
        this.templateUrl = 'termsofuse.html';
        this.controllerAs = 'vm';
        this.controller = TermsViewController;
    }
    return TermsViewComponent;
}());
angular
    .module('application')
    .component('viewTermsSection', new TermsViewComponent());

//# sourceMappingURL=termsofuse.view.component.js.map
